<template>
  <a :href="link" target="_blank" :class="{'no-click' : uc}">
    <div class="toy-button" :class="{'under-construction' : uc}">
      <div class="button-text">
        {{text}}
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    name: "Button",
    props: {
      text: "",
      link: "",
      uc: false
    },
  }
</script>

<style scoped lang="scss">
  .toy-button {
    color: #f8f3d9;
    margin: 10px;
    padding: 20px;
    border: 2px solid #f8f3d9;
    border-radius: 4px;
    text-align: center;
    text-transform: uppercase;
    position: relative;
    overflow: hidden;
    &:hover {
      cursor: pointer;
      color: #302823;
      font-weight: bold;
      &:before {
        width: 120%;
        animation-name: button-color;
        animation-duration: 1s;
        animation-iteration-count: infinite;
      }
    }
    &:before {
      position: absolute;
      transition: .3s;
      content: '';
      width: 0;
      bottom: 0;
      left: -10%;
      height: 100%;
      transform: skewX(20deg);
      background: #f8f3d9;
    }

    &.under-construction {
      &:before {
        position: absolute;
        content: '準備中';
        font-weight: bold;
        color: #302823;
        font-style: normal;
        width: 100%;
        bottom: 0;
        left: 0;
        height: 100%;
        background: #f8f3d9;
        transform: skewX(0);
        opacity: 0.9;
      }
      &:hover {
        cursor: text;
        color: #f8f3d9;
        font-weight: bold;
        &:before {
          width: 100%;
          height: 100%;
          animation: none;
        }
      }
    }
  }

  .no-click {
    pointer-events: none;
  }

  .button-text {
    position: relative;
    z-index: 1;
  }

  @keyframes button-color {
    0% {
      background: #f8f3d9;
    }

    70% {
      background: #98e3b4;
    }

    100% {
      background: #f8f3d9;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Controlls/Button.vue